export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_25-1e92538fa05d9287f3df14ef43e05d1d.jpg";